var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"f-search",domProps:{"value":_vm.v},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"change":function($event){return _vm.$emit('change', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }